import { setCurrentUser, setName, setUserId } from '../components/login/loginSlice';

export function hasMultipleAccounts(users) {
    return Array.isArray(users) && users.length > 1;
}

export function applyAccountSwitch(dispatch, user) {
    if (!user) return;
    dispatch(setName(user.company_name));
    dispatch(setUserId(user.user_id));
    dispatch(setCurrentUser({
        ...user,
        id: user.user_id,
        name: user.company_name,
    }));
}
